export enum FEATURE_TYPES {
    DataIntegration = 'DataIntegration',
    DataIntegrationAndSSO = 'SSO,DataIntegration',
    IMPORT = 'IMPORT',
    EXPORT = 'EXPORT',
    SYNC = 'SYNC',
    SSO = 'SSO',
}

export enum APPLICATION_BADGE {
    GG4L_MEMBER = 'GG4L_MEMBER',
    IMS_TRUSTED_APP = 'IMS_TRUSTED_APP',
    ONE_ROSTER_CERTIFIED = 'ONE_ROSTER_CERTIFIED',
    SDPC_MEMBER = 'SDPC_MEMBER',
    SPECIAL_OFFER = 'SPECIAL_OFFER',
}

export enum APPLICATION_BADGE_FRIENDLY_NAME {
    GG4L_MEMBER = 'SchoolDay Member',
    IMS_TRUSTED_APP = 'IMS TrustEd App',
    ONE_ROSTER_CERTIFIED = 'One Roster certified',
    SDPC_MEMBER = 'SDPC Member',
    SPECIAL_OFFER = 'Special Offer',
}

export const PII_SHIELD_GALLERY_FILTER_CATEGORY_GUID = 'PII_SHIELD';
